import React, { useContext, useEffect } from 'react'
import { midas } from '@resurs/midas'
import { LocaleState } from '@merchant-portal/merchant-portal-base'
import Page from '../../../internal/Page'
import { getText } from '../../../internal/TextLabels'
import { Countries } from '../../../models/countries'
import { addHumanyScript, countryData, removeHumanyScript } from './humanyUtils'

const Humany = () => {
  const locale = useContext(LocaleState)

  const getWidgetName = () =>
    countryData[locale.country].widgetName ||
    countryData[Countries.SE].widgetName

  const getContentLink = () =>
    countryData[locale.country].contentLink ||
    countryData[Countries.SE].contentLink

  useEffect(() => {
    addHumanyScript(() => {
      if (window?.Humany?.Widgets?.Coordinator) {
        window.Humany.Widgets.Coordinator.trigger(
          document.getElementById('humany-trigger'),
          { widgetName: getWidgetName() },
        )
      }
    })

    return () => {
      if (window?.Humany?.Widgets?.Coordinator) {
        window.Humany.Widgets.Coordinator.destroy(getWidgetName())
      }
      removeHumanyScript()
    }
  }, [locale.country])

  return (
    <Page title={getText('support.title')}>
      <div style={{ padding: '2rem' }}>
        <a id="humany-trigger" href={getContentLink()}>
          <div className={midas.loading} />
        </a>
      </div>
    </Page>
  )
}

export default Humany
